export const formatDate = (date: Date, locale = "en-US"): string => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
  };

  return new Intl.DateTimeFormat(locale, options).format(date);
};

export const formatDateWithoutDay = (date: Date, locale = "en-US"): string => {
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "2-digit",
    year: "numeric",
  };

  return new Intl.DateTimeFormat(locale, options).format(date);
};
